export default "__VITE_ASSET__BYvrJ6Sz__"